import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TrainingLogByDayFromHttp, TrainingLogByYearFromHttp } from '../../models/stats.model';
import { StatsApi } from '../stats.api';

@Injectable({
  providedIn: 'root',
  useClass: StatsApi
})
export abstract class IStatsApi {
  abstract getStatsByDays(startDate: Date, endDate: Date, sportType: string, userId?: number): Observable<TrainingLogByDayFromHttp>;

  abstract getAllStatsByYear(sportType: string, userId?: number): Observable<TrainingLogByYearFromHttp>;
}
